import { Component, EventEmitter, HostBinding, Input, OnDestroy, Output, TemplateRef } from '@angular/core';
import { ActorObject } from '../../shared/datamodel';

import { LssEntity } from '../../configuration/store/lss-entity.datamodel';
import { AppService } from '../../application/app.service';
import { ORG_OGU_COMPONENTS_TYPES } from '../../publish/component/store/component.datamodel';
import { Subscription } from 'rxjs';
import { DeploymentService } from '../../deployments/store/deployment.service';

@Component({
    selector: 'ama-ng-app-store-hierarchy-list',
    templateUrl: './hierarchy-list.component.html',
    styleUrls: ['./hierarchy-list.component.scss'],
    standalone: false
})
export class HierarchyListComponent<E extends LssEntity<E>> implements OnDestroy {
  @Input() actorTemplate!: TemplateRef<{ $implicit: E, depth: number }>;
  @Input() currentItem?: E;
  @Input() items: E[] = [];
  @Input() selectedActor?: ActorObject | undefined;
  @Input() hierarchyNodeId: string | undefined;
  @Input() @HostBinding("style.--depth") depth = 0;

  @Output() expandEntity = new EventEmitter<E>();
  @Output() collapseEntity = new EventEmitter<E>();
  @Output() loadEntity = new EventEmitter<E>();

  canDeployOrgOguLevels = false;

  private readonly subscription = new Subscription();

  constructor(private readonly appService: AppService, readonly deploymentService: DeploymentService) {
    this.subscription.add(this.appService.detailedApp$.subscribe(app => {
      this.canDeployOrgOguLevels = ORG_OGU_COMPONENTS_TYPES.includes(
        appService.getAppComponentsType(app.components, app.applicationType)
      );
    }));
  }

  loadEntityHierarchy(event: E) {
    this.loadEntity.emit(event);
  }

  /**
   * Dispatch toggle entity collapsed state action and stop event propagation
   * @param entity LSS entity
   */
  toggle(entity: E) {
    if (entity.isCollapsed) {
      this.expandEntity.emit(entity);
    } else {
      this.collapseEntity.emit(entity);
    }
  }

  /**
   * Track by function for ngFor
   * @param _index Item index
   * @param entity LSS entity
   */
  trackFn(_index: number, entity: E): string {
    return `${entity.actor.actorType}.${entity.actor.actorName}`;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
